// src/pages/Education.js

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import translations from '../lang';
import HoverHint from '../components/HoverHint';
import Sidebar from '../components/Sidebar';
import ProjectContent from '../components/ProjectContent';
import './Education.css'; 
import '../components/Project.css'; // 如果项目区块需要独立样式

function Education({ lang }) {
  const location = useLocation();

  // 独立状态：本科 Modal、研究生 Modal
  const [showBachelorModal, setShowBachelorModal] = useState(false);
  const [showMasterModal, setShowMasterModal] = useState(false);

// 本科项目区块
const bachelorProjects = translations.bachelorProjects;
const [activeBachelorId, setActiveBachelorId] = useState(bachelorProjects[0].id);

// 研究生项目区块
const masterProjects = translations.masterProjects;
const [activeMasterId, setActiveMasterId] = useState(masterProjects[0].id);


  const handleCloseModal = () => {
    setShowBachelorModal(false);
    setShowMasterModal(false);
  };

useEffect(() => {
  if (location.hash) {
    const anchor = document.querySelector(location.hash);
    if (anchor) {
      setTimeout(() => {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0);
    }
  }
}, [location]);




  return (
    <section className="education-section">
      <h1 className="education-title">
        {translations.education.title[lang]}
      </h1>

      <div className="content-container">
        {/* === 本科阶段 === */}
        <HoverHint text={translations.HoverHint[lang]}>
          <div id="bachelor" className="stage-box">
            <div
              className="stage-header"
              onClick={() => setShowBachelorModal(true)}
            >
              <h3 className="stage-heading">
                {translations.education.bachelor[lang]}
                <span style={{ marginLeft: '20px' }}>2020.9--2024.7</span>
              </h3>
              {translations.education.bachelorDesc[lang].map((para, index) => (
                <p className="stage-para" key={index}>
                  {para}
                </p>
              ))}
            </div>
            <div className="plus-moreinfo">+</div>
          </div>
        </HoverHint>

        {/* === 本科项目区块 === */}
        <div className="stage-box">
          <div className="project-layout">
                <Sidebar
                  menuItems={bachelorProjects.map(proj => ({
                    id: proj.id,
                    title: proj.title[lang]
                  }))}
                  onSelect={setActiveBachelorId}
                  activeId={activeBachelorId}
                />
                <ProjectContent
                  projects={bachelorProjects}
                  activeId={activeBachelorId}
                  lang={lang}
                />
          </div>
        </div>

        {/* === 研究生阶段 === */}
        <HoverHint text={translations.HoverHint[lang]}>
          <div id="master" className="stage-box">
            <div
              className="stage-header"
              onClick={() => setShowMasterModal(true)}
            >
              <h3 className="stage-heading">
                {translations.education.master[lang]}
                <span style={{ marginLeft: '20px' }}>2024.9--2026.9</span>
              </h3>
              {translations.education.masterDesc[lang].map((para, index) => (
                <p className="stage-para" key={index}>
                  {para}
                </p>
              ))}
            </div>
            <div className="plus-moreinfo">+</div>
          </div>
        </HoverHint>
      </div>

       {/* === 研究生项目区块 === */}
        <div className="stage-box">
          <div className="project-layout">
            <Sidebar
              menuItems={masterProjects.map(proj => ({
                id: proj.id,
                title: proj.title[lang]
              }))}
              onSelect={setActiveMasterId}
              activeId={activeMasterId}
            />
            <ProjectContent
              projects={masterProjects}
              activeId={activeMasterId}
              lang={lang}
            />

          </div>
        </div>

      {/* === 本科 Modal === */}
      {showBachelorModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close" onClick={handleCloseModal}>
              &times;
            </button>
                <div className="school-header">
                <img
                  src="assets/img/unilogo.svg"
                  alt="校徽"
                  className="school-logo round-logo"
                />
                <h2 className="school-title">
                  {translations.education.undergradUni.name[lang]}
                </h2>
              </div>
            <div className="modal-scroll">
              <div className="school-body">
                {translations.education.undergradUni.schoolinfo[lang].map((para, index) => (
                  <p className="stage-para" key={index}>
                    {para}
                  </p>
                  ))}
                <h3>{translations.education.undergradUni.major[lang]}</h3>
                  {translations.education.undergradUni.majorinfo[lang].map((para, index) => (
                  <p className="stage-para" key={index}>
                    {para}
                  </p>
                  ))}
                <a
                  href={translations.education.undergradUni.link[lang]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="school-link"
                >
                  {translations.education.undergradUni.schoolencyclopedia[lang]} &gt;
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* === 研究生 Modal === */}
      {showMasterModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close" onClick={handleCloseModal}>
              &times;
            </button>
            <div className="school-header">
              <img
                src="assets/img/gradlogo.svg"
                alt="研究生校徽"
                className="school-logo square-logo"
              />
              <h2 className="school-title">
                {translations.education.graduateUni.name[lang]}
              </h2>
            </div>
           <div className="modal-scroll">
              <div className="school-body">
                {translations.education.graduateUni.schoolinfo[lang].map((para, index) => (
                  <p className="stage-para" key={index}>
                    {para}
                  </p>
                  ))}
                <h3>{translations.education.graduateUni.major[lang]}</h3>
                  {translations.education.undergradUni.majorinfo[lang].map((para, index) => (
                  <p className="stage-para" key={index}>
                    {para}
                  </p>
                  ))}
                <a
                  href={translations.education.graduateUni.link[lang]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="school-link"
                >
                  {translations.education.graduateUni.schoolencyclopedia[lang]} &gt;
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Education;
